import React from "react";
import { X } from "react-feather";
import "./DynamicAlertDialog.css"; // reusing same styles

export default function DynamicAlertBoxGlobal({
  show = false,
  title = "Alert",
  message = "",
  type = "info", // success | error | warning | info
  onClose = () => {},
}) {
  if (!show) return null;

  return (
    <div className="alert-dialog-backdrop" onClick={onClose}>
      <div
        className={`alert-dialog alert-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="alert-close-icon"
          onClick={onClose}
          aria-label="Close Alert"
        >
          <X size={18} />
        </button>

        <div className="alert-content">
          <h3 className="alert-title">{title}</h3>
          <p className="alert-message">{message}</p>
        </div>
      </div>
    </div>
  );
}
